// Monta o texto do aviso de exclusão de um tamanho cadastrado.
// Fica fora do componente para poder ser testado sem React/DOM.

const plural = (qtde, singular, pluralWord) =>
  `${qtde} ${qtde === 1 ? singular : pluralWord}`;

// usage vem de GET /products/sizes/:sizeId/usage
// { label, grids, products, stock }
export function buildSizeDeleteMessage(usage = {}) {
  const label = usage.label ?? "";
  const grids = usage.grids || 0;
  const products = usage.products || 0;
  const stock = usage.stock || 0;

  if (grids === 0) {
    return {
      title: `Excluir o tamanho ${label}?`,
      text: "Este tamanho não está sendo usado em nenhum produto.",
    };
  }

  const partes = [
    `Ele será removido de ${plural(products, "produto", "produtos")}`,
    `apagando ${plural(grids, "célula", "células")} da grade`,
  ];

  if (stock > 0) {
    partes.push(`e ${plural(stock, "peça", "peças")} em estoque`);
  }

  return {
    title: `Excluir o tamanho ${label}?`,
    text: `${partes.join(", ")}. Você não poderá reverter isso!`,
  };
}

// Resumo mostrado depois da exclusão.
export function buildSizeDeletedMessage(deleted = {}) {
  const removedGrids = deleted.removedGrids || 0;

  if (removedGrids === 0) {
    return "Tamanho excluído com sucesso!";
  }

  return `Tamanho excluído com sucesso! ${plural(
    removedGrids,
    "célula",
    "células",
  )} da grade também ${removedGrids === 1 ? "foi removida" : "foram removidas"}.`;
}
